import { graph, organization, website, webPage } from "@/seo/schema";

const BASE = "https://dimedial.studio";

const OG_PAGES = ["home", "autopilot", "robbie", "google", "social", "homepage", "hosting", "preise", "kontakt", "video", "videostudio", "audio", "agentur", "kunden", "presse", "cloud", "buero", "gamechanger", "ueber-uns", "tickets"];
const OG_ALIAS = { "dein-buero": "buero", brain: "buero", "filmproduktion-herford": "video", filmproduktion: "video", "webdesign-herford": "homepage", webdesign: "homepage", tonstudio: "audio", portal: "kunden" };

export const ogImage = (path) => {
  const slug = (path || "/").split("?")[0].split("/").filter(Boolean)[0] || "home";
  const key = OG_ALIAS[slug] || slug;
  return `${BASE}/og/v2/${OG_PAGES.includes(key) ? key : "default"}.jpg`;
};

const Seo = ({ title, description, path = "/", jsonLd, image, noindex = false, keywords }) => {
  const ld = jsonLd || (!noindex && graph(website(), organization(), webPage(path, title, description)));

  // React 19 hebt <title>/<meta>/<link> selbst in den <head> (natives Metadata-Hoisting).
  // KEIN react-helmet-async mehr – sonst entstand pro Tag eine zweite Garnitur im Live-DOM
  // (Helmet + React-19-Hoisting). So bleibt pro Seite genau EIN Title/Description/Canonical.
  return (
  <>
    <title>{title}</title>
    {noindex && <meta name="robots" content="noindex,nofollow" />}
    <meta name="description" content={description} />
    {keywords && <meta name="keywords" content={keywords} />}
    <link rel="canonical" href={`${BASE}${path}`} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="DIMEDIAL Studio" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${BASE}${path}`} />
    <meta property="og:image" content={image || ogImage(path)} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image || ogImage(path)} />
    {ld && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />}
  </>
  );
};

export default Seo;
